






























import { Component, Vue, Ref } from 'vue-property-decorator'
  @Component({})
export default class extends Vue {
    private sortMap:any = {
      'descending': 1,
      'ascending': -1,
      null: 0
    }
    private searchParams:any = {
      classroomId: '',
      name: '',
      sort_name: 0,
      sort_remark: 0
    }
    get table() {
      return this.$refs.table as any
    }
    created() {
    }
    onSortChange(data:{column:any, prop:string, order: null|string}) {
      for (let key in this.searchParams) {
        if (key.indexOf('sort_') > -1) {
          this.searchParams[key] = 0
        }
      }
      let sortKey = 'sort_' + data.prop
      let sortVal = 0
      switch (data.order) {
        case 'descending':
          sortVal = -1
          break
        case 'ascending':
          sortVal = 1
          break
        case null:
          sortVal = 0
          break
      }
      this.searchParams[sortKey] = sortVal
      this.search()
    }
    edit(id: any) {
      this.$router.push({
        path: '/teachingProtection/assessment/custom/edit',
        query: {
          id: id
        }
      })
    }
    search() {
      this.table.search()
    }
}
